import React , { useState, useRef, useEffect } from 'react';
import app from "./app"
import { GridWrap, ListWrap, Elements } from "./helpers"

const string2parse = function(data) { 
    if (typeof data === 'string') {
        try {
            return JSON.parse(data); 
        } catch (e) {
            console.error('Invalid JSON string:', e);
            return data; 
        }
    } 
    // If data is already parsed (not a string), return it as-is
    return data;
}

export const FooterAi = function(props){
    const {index, widgetType, mode, device, appData} = props;  
    const data = string2parse(props.data) 

    useEffect(() => {  
    }, []);
      

    let footerNav = [
        { 
            pageIdentifier:"terms",
            pageName:"Terms of use",
            pageUrl:"terms-of-use"
        },
        { 
            pageIdentifier:"privacy",
            pageName:"Privacy Policy",
            pageUrl:"privacy-policy"
        }
    ];
    
    // pages.forEach(function (value, index) {
    //     if (value.pageIdentifier || value.pageid === "about") {
    //         if (aboutPage) {
    //             aboutPage = false;
    //             footerNav.push(value)
    //         }
    //     }
    //     if (value.pageIdentifier || value.pageid === "contact") {
    //         if (contactPage) {
    //             contactPage = false;
    //             footerNav.push(value)
    //         }
    //     }
    //     else{
    //         if (termsPage) {
    //             termsPage = false;
    //             footerNav.push({ 
    //                 pageIdentifier:"terms",
    //                 pageName:"Terms of use",
    //                 pageUrl:"terms-of-use"
    //             })
    //         }
    //         if (privacyPage) {
    //             privacyPage = false;
    //             footerNav.push({ 
    //                 pageIdentifier:"privacy",
    //                 pageName:"Privacy Policy",
    //                 pageUrl:"privacy-policy"
    //             })
    //         }
    //     }
    // });
    // console.log("footer-data", data)
    
    let style = `
    #footerNavigation li.on a{
        background:${app.getColor(data.elements.footerNavigation.properties.backgroundClick)} !important;
        color:${app.getColor(data.elements.footerNavigation.properties.textColorClick)} !important;
        border-color:${app.getColor(data.elements.footerNavigation.properties.borderColorClick)} !important;
    } 
    #footerNavigation li:hover a{
        background:${app.getColor(data.elements.footerNavigation.properties.backgroundHover)} !important;
        color:${app.getColor(data.elements.footerNavigation.properties.textColorHover)} !important;
        border-color:${app.getColor(data.elements.footerNavigation.properties.borderColorHover)} !important;
    } 
    `
 

    let containerWidth = "container-fluid";
    let hideFooter = "";
    if(mode === "live"){
        if(data.properties.isFluid === "container"){
            containerWidth = "container"
        }
    }
    if(device === "desktop"){ 
        if(data.settings.hideFooterWeb) {
            hideFooter = "d-none";
        }
    }
    else {
        if(data.settings.hideFooter) {
            hideFooter = "d-none";
        }
    }
    if(data.properties.footerLayout === "2"){ 
        return <div className={app.getMode(mode)?`footerContainerAi ${hideFooter} footerLayout-${data.properties.footerLayout}`:`footerContainerAi ${hideFooter} footerLayout-${data.properties.footerLayout}`} style={app.getMode(mode)?app.getStyle(data, device):null} widget-type={data.widgetType}>
                <style type='text/css'>{style}</style>
            <div className={`${containerWidth} px-0`}>
                <div className="container-fluid p-0 position-relative footer-top"> 
                <div className={`row row-cols-1 row-cols-lg-4 align-items-stretch justify-content-center`}>
                   {data.elements.logo.properties.showWeb || data.elements.locationSummary.properties.showWeb?<div className='col'>
                        <Elements row={data.elements.logo} id={"logo"} device={device} mode={mode} classType={`justify-content-${data.elements.logo.properties.textAlignment} hideAi`}/>
                        <Elements row={data.elements.locationSummary} id={"locationSummary"} device={device} mode={mode} classType="hideAi"/>
                    </div>:null}
                    {data.elements.hourHeading.properties.showWeb || data.elements.hourSummary.properties.showWeb?<div className='col'>
                        <Elements row={data.elements.hourHeading} id={"hourHeading"} device={device} mode={mode} classType="hideAi"/>
                        <Elements row={data.elements.hourSummary} id={"hourSummary"} device={device} mode={mode} classType="hideAi"/>
                    </div>:null}
                    {data.elements.socialHeading.properties.showWeb || data.elements.footerSocialInfo.properties.showWeb?<div className='col'>
                        <Elements row={data.elements.socialHeading} id={"socialHeading"} device={device} mode={mode} classType="hideAi"/>
                        <Elements row={data.elements.footerSocialInfo} id={"footerSocialInfo"} device={device} mode={mode} classType={`hideAi justify-content-${data.elements.footerSocialInfo.properties.textAlignment}`}/>
                    </div>:null}
                    {data.elements.contactHeading.properties.showWeb || data.elements.contactLinks.properties.showWeb?<div className='col'>
                        <Elements row={data.elements.contactHeading} id={"contactHeading"} device={device} mode={mode} classType="hideAi"/>
                        <Elements row={data.elements.contactLinks} id={"contactLinks"} device={device} mode={mode} classType="hideAi"/>
                    </div>:null}
                </div> 
                </div>
                <div className="container-fluid copyright text-center p-0 mt-3">
                    <Elements row={data.elements.copyright} id={"copyright"} device={device} mode={mode} classType="hideAi" />
                </div>  
            </div>
        </div>
    }
    else{
        return <div className={app.getMode(mode)?`footerContainerAi ${hideFooter} footerLayout-${data.properties.footerLayout}`:`footerContainerAi ${hideFooter} footerLayout-${data.properties.footerLayout}`} style={app.getMode(mode)?app.getStyle(data, device):null} widget-type={data.widgetType}>
        <style type='text/css'>{style}</style>
        <div className={`${containerWidth} px-0`}>
            <div className="container-fluid position-relative footer-top"> 
            <div className={`row d-flex align-items-center justify-content-between`}> 
                <div className={device === "mobile" && !data.elements.logo.properties.show?`col-12 col-lg-3`:`col-12 col-lg-3`}>
                    <Elements row={data.elements.logo} id={"logo"} device={device} mode={mode} classType={`justify-content-${data.elements.logo.properties.textAlignment}`}/>
                </div>
                <div className={`col-12 col-lg-6 text-center d-flex align-items-center justify-content-center`}>
                    <Elements data={data} navigation={footerNav} row={data.elements.footerNavigation} id={"footerNavigation"} device={device} mode={mode} classType={`w-100 justify-content-${data.elements.footerNavigation.properties.textAlignment}`}/>
                </div>
                <div className='col-12 col-lg-3 float-lg-end'>
                    <Elements row={data.elements.footerSocialInfo} id={"footerSocialInfo"} device={device} mode={mode} classType={`justify-content-${data.elements.footerSocialInfo.properties.textAlignment}`}/>
                </div>
            </div> 
            </div>
            <div className="container-fluid copyright text-center p-0 mt-3">
                <Elements row={data.elements.copyright} id={"copyright"} device={device} mode={mode} classType="hideAi" />
            </div>
        </div>
</div>
    }

}
export default FooterAi;